import { create } from 'zustand'

export interface LiveTrigger {
  triggerId: string
  deviceId: string
  lat: number
  lon: number
  iqr: number
  cav: number
  staLtaRatio: number
  confirmed: boolean
  ts: number
}

export interface LiveDevice {
  deviceId: string
  lat: number
  lon: number
  battery?: number
  ts: number
}

const TRIGGER_TTL = 5 * 60_000
const TRIGGER_MAX = 300
const DEVICE_TTL = 12 * 60_000

interface LiveState {
  triggers: LiveTrigger[]
  devices: Record<string, LiveDevice>
  pushTrigger: (t: LiveTrigger) => void
  pushDevice: (d: LiveDevice) => void
  prune: () => void
}

/**
 * 实时触发/设备心跳（MQTT 直写，不进 query cache）。
 * 触发保留 5 分钟滑动窗口供地图脉冲与站点面板消费。
 */
export const useLiveStore = create<LiveState>((set) => ({
  triggers: [],
  devices: {},
  pushTrigger: (t) =>
    set((s) => {
      const next = [t, ...s.triggers.filter((x) => x.triggerId !== t.triggerId)]
      const cutoff = t.ts - TRIGGER_TTL
      return { triggers: next.filter((x) => x.ts >= cutoff).slice(0, TRIGGER_MAX) }
    }),
  pushDevice: (d) =>
    set((s) => ({
      devices: { ...s.devices, [d.deviceId]: { ...(s.devices[d.deviceId] ?? {}), ...d } },
    })),
  prune: () =>
    set((s) => {
      const now = Date.now()
      return {
        triggers: s.triggers.filter((x) => now - x.ts <= TRIGGER_TTL),
        devices: Object.fromEntries(
          Object.entries(s.devices).filter(([, d]) => now - d.ts <= DEVICE_TTL),
        ),
      }
    }),
}))
